<template lang="pug">
section(id='empresa-bloco-inserir-pessoa-manualmente')
    h3.empresa-bloco-inserir-pessoa-manualmente__title Agregar persona manualmente

    el-collapse
        el-collapse-item(name='cadastroManual')
            template(slot='title')
                h2.cadastro-pessoa__subtitulo Registrar persona

            el-card(:body-style='{ padding: "20px" }' shadow='never')
                el-form(
                    class='col-12'
                    label-position='top'
                    :model='formulario'
                    :rules='regras'
                    ref='formCadastroPessoaRef'
                )
                    // Row 1: Identificación — País + CUIT + Nombre o Razón Social
                    div.row
                        el-form-item(
                            class='col-3'
                            label='País'
                            prop='pais'
                        )
                            el-input(
                                id='pais'
                                v-model='formulario.pais'
                                disabled
                            )

                        el-form-item(
                            class='col-3'
                            label='CUIT'
                            prop='cuit'
                        )
                            el-input(
                                id='cuit'
                                v-model='formulario.cuit'
                                placeholder='CUIT'
                                :maxlength='13'
                                @input='formatCuit'
                            )

                        el-form-item(
                            class='col-6'
                            label='Nombre o Razón Social'
                            prop='nomeRazaoSocial'
                        )
                            el-input(
                                id='nomeRazaoSocial'
                                v-model='formulario.nomeRazaoSocial'
                                placeholder='Nombre o Razón Social'
                            )

                    // Row 2: Contacto — E-mail + Teléfono + ID del Cliente
                    div.row
                        el-form-item(
                            class='col-6'
                            label='E-mail'
                            prop='email'
                        )
                            el-input(
                                id='email'
                                v-model='formulario.email'
                                placeholder='E-mail'
                            )

                        el-form-item(
                            class='col-3'
                            label='Teléfono'
                            prop='telefone'
                        )
                            el-input(
                                id='telefone'
                                v-model='formulario.telefone'
                                placeholder='Teléfono'
                                @input='telefone'
                            )

                        el-form-item(
                            class='col-3'
                            label='ID del Cliente'
                            prop='idCliente'
                        )
                            el-input(
                                id='idCliente'
                                v-model='formulario.idCliente'
                                placeholder='ID del Cliente'
                                :maxlength='200'
                            )

                    // Row 3: Ubicación — Provincia + Departamento + Localidad + acción
                    div.row
                        el-form-item(
                            class='col-3'
                            label='Provincia'
                            prop='provincia'
                        )
                            el-select(
                                id='provincia'
                                v-model='formulario.provincia'
                                :loading='loading.provincias'
                                :validate-event='false'
                                placeholder='Seleccione'
                                clearable
                                filterable
                                value-key='nome'
                                @change='onChangeProvincia'
                            )
                                el-option(
                                    v-for='opcao in opcoes.provincias'
                                    :key="'provincia-' + opcao.id"
                                    :label='opcao.nome'
                                    :value='opcao'
                                )

                        el-form-item(
                            class='col-3'
                            label='Departamento'
                            prop='departamento'
                        )
                            el-select(
                                id='departamento'
                                v-model='formulario.departamento'
                                :loading='loading.departamentos'
                                :disabled='!formulario.provincia || !formulario.provincia.id'
                                :validate-event='false'
                                placeholder='Seleccione'
                                clearable
                                filterable
                                value-key='nome'
                                @change='onChangeDepartamento'
                            )
                                el-option(
                                    v-for='opcao in opcoes.departamentos'
                                    :key="'departamento-' + opcao.id"
                                    :label='opcao.nome'
                                    :value='opcao'
                                )

                        el-form-item(
                            class='col-3'
                            label='Localidad'
                            prop='localidade'
                        )
                            el-select(
                                id='localidade'
                                v-model='formulario.localidade'
                                :loading='loading.localidades'
                                :disabled='!formulario.departamento || !formulario.departamento.id'
                                :validate-event='false'
                                placeholder='Seleccione'
                                clearable
                                filterable
                                value-key='nome'
                            )
                                el-option(
                                    v-for='opcao in opcoes.localidades'
                                    :key="'localidade-' + opcao.id"
                                    :label='opcao.nome'
                                    :value='opcao'
                                )

                        el-form-item(
                            class='col-3'
                            label=' '
                        )
                            el-button(
                                id='adicionar'
                                type='primary'
                                :disabled='botaoAgregarDesabilitado'
                                @click='adicionar'
                            )
                                i(:class="adicionando ? 'el-icon-loading' : 'el-icon-plus'")
                                | Agregar a la lista
</template>

<script>
import debounce from 'lodash/debounce';
import { validateCuit } from '@/utils/validations/cuit';
import LocalidadeService from '@/services/LocalidadeService';
import PessoaServiceArgentina from '@/services/PessoaServiceArgentina.js';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default {
    name: 'EmpresaBlocoInserirPessoaManualmente',

    props: {
        pessoasJaAdicionadas: {
            type: Array,
            required: true
        }
    },

    data() {
        const validarCuit = (_, value, callback) => {
            if (!validateCuit(value)) {
                callback('CUIT en formato inválido');
                return;
            }
            callback();
        };

        const validarEmail = (_, value, callback) => {
            if (value && !EMAIL_REGEX.test(value)) {
                callback('E-mail inválido');
            } else {
                callback();
            }
        };

        const validarObjeto = (_, value, callback) => {
            if (!value || !value.id) {
                callback('Campo obligatorio');
            } else {
                callback();
            }
        };

        return {
            adicionando: false,
            mascara: {
                cuit: '##-########-#',
                telefone: '## ####-####'
            },
            loading: {
                provincias: false,
                departamentos: false,
                localidades: false
            },
            opcoes: {
                provincias: [],
                departamentos: [],
                localidades: []
            },
            formulario: {
                pais: 'Argentina',
                nomeRazaoSocial: '',
                cuit: '',
                email: '',
                telefone: '',
                provincia: {
                    id: '',
                    nome: ''
                },
                departamento: {
                    id: '',
                    nome: ''
                },
                localidade: {
                    id: '',
                    nome: ''
                },
                idCliente: ''
            },
            regras: {
                nomeRazaoSocial: [
                    { required: true, message: 'Campo obligatorio', trigger: 'blur' },
                    { min: 3, message: 'Introduzca un mínimo de 3 caracteres para registrar', trigger: 'blur' }
                ],
                cuit: [
                    { required: true, message: 'Campo obligatorio', trigger: 'blur' },
                    { validator: validarCuit, trigger: 'blur' }
                ],
                email: [
                    { validator: validarEmail, trigger: ['blur', 'change'] }
                ],
                provincia: [
                    { required: true, validator: validarObjeto, trigger: 'change' }
                ],
                departamento: [
                    { required: true, validator: validarObjeto, trigger: 'change' }
                ],
                localidade: [
                    { required: true, validator: validarObjeto, trigger: 'change' }
                ]
            },
            pessoaJaCadastrada: false
        };
    },

    computed: {
        isDuplicado() {
            if (!this.formulario.cuit) return false;
            const hasCuit = !!this.pessoasJaAdicionadas?.find(
                p => p.cuit === this.formulario.cuit
            );

            if (hasCuit) {
                this.$notify.error({
                    title: 'CUIT duplicado',
                    message: 'Este CUIT ya está en la lista. Verifique el número ingresado.'
                });
            }
            return hasCuit;
        },

        botaoAgregarDesabilitado() {
            return this.isDuplicado || !this.formularioPreenchido || this.pessoaJaCadastrada || this.adicionando;
        },

        formularioPreenchido() {
            const {
                nomeRazaoSocial,
                cuit,
                email,
                provincia,
                departamento,
                localidade
            } = this.formulario;

            return (
                nomeRazaoSocial.trim().length >= 3 &&
                validateCuit(cuit) &&
                this.emailValido(email) &&
                this.objetoSelecionado(provincia) &&
                this.objetoSelecionado(departamento) &&
                this.objetoSelecionado(localidade)
            );
        }
    },

    watch: {
        'formulario.cuit'(novoCuit) {
            this.debouncedBuscarPorCuit(novoCuit);
        }
    },

    methods: {
        validarFormulario() {
            return new Promise(resolve => {
                this.$refs.formCadastroPessoaRef.validate(valid => resolve(!!valid));
            });
        },

        emailValido(email) {
            return !email || EMAIL_REGEX.test(email);
        },

        objetoSelecionado(value) {
            return !!value?.id;
        },

        formatCuit(value) {
            const cleaned = value.replace(/\D/g, '').slice(0, 11);
            let formatted = cleaned;

            if (cleaned.length >= 3) {
                formatted = cleaned.slice(0, 2) + '-' + cleaned.slice(2);
            }
            if (cleaned.length >= 10) {
                formatted = cleaned.slice(0, 2) + '-' + cleaned.slice(2, 10) + '-' + cleaned.slice(10);
            }

            this.formulario.cuit = formatted;
        },

        telefone(value) {
            const cleaned = value.replace(/\D/g, '');
            let formatted = cleaned;

            if (cleaned.length > 12) {
                if (cleaned.length >= 2) {
                    formatted = cleaned.slice(0, 1) + ' ' + cleaned.slice(1);
                }
                if (cleaned.length >= 3) {
                    formatted = cleaned.slice(0, 1) + ' ' + cleaned.slice(1, 3) + ' ' + cleaned.slice(3);
                }
                if (cleaned.length >= 7) {
                    formatted = cleaned.slice(0, 1) + ' ' + cleaned.slice(1, 3) + ' ' + cleaned.slice(3, 7) + '-' + cleaned.slice(7);
                }
            } else {
                if (cleaned.length >= 2) {
                    formatted = cleaned.slice(0, 2) + ' ' + cleaned.slice(2);
                }
                if (cleaned.length >= 6) {
                    formatted = cleaned.slice(0, 2) + ' ' + cleaned.slice(2, 6) + '-' + cleaned.slice(6);
                }
            }

            this.formulario.telefone = formatted;
        },

        onChangeProvincia() {
            const data = { id: '', nome: '' };
            this.formulario.departamento = data;
            this.formulario.localidade = data;
            this.opcoes.departamentos = [];
            this.opcoes.localidades = [];
            this.limparValidacaoLocalizacao(['departamento', 'localidade']);
            if (!this.formulario.provincia) return;
            this.listarDepartamentos(this.formulario.provincia.id);
        },

        onChangeDepartamento() {
            const data = { id: '', nome: '' };
            this.formulario.localidade = data;
            this.opcoes.localidades = [];
            this.limparValidacaoLocalizacao(['localidade']);
            if (!this.formulario.departamento) return;
            this.listarLocalidades(this.formulario.departamento.id);
        },

        limparValidacaoLocalizacao(campos) {
            this.$nextTick(() => {
                this.$refs.formCadastroPessoaRef.clearValidate(campos);
            });
        },

        orderName(a, b) {
            const nameA = a.nome.toUpperCase();
            const nameB = b.nome.toUpperCase();
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
        },

        async listarProvincias() {
            try {
                this.loading.provincias = true;
                const { data } = await LocalidadeService.buscarLocalidadeNivelUm();
                this.opcoes.provincias = data
                    .map(item => ({ nome: item.nome, id: item.id }))
                    .sort((a, b) => this.orderName(a, b));
            } catch {
                this.$notify.error({ message: 'Error al buscar provincias.' });
            } finally {
                this.loading.provincias = false;
            }
        },

        async listarDepartamentos(provinciaId) {
            try {
                this.loading.departamentos = true;
                const { data } = await LocalidadeService.buscarLocalidadeNivelDois(provinciaId);
                this.opcoes.departamentos = data
                    .map(item => ({ nome: item.nome, id: item.id }))
                    .sort((a, b) => this.orderName(a, b));
            } catch {
                this.$notify.error({ message: 'Error al buscar departamentos.' });
            } finally {
                this.loading.departamentos = false;
            }
        },

        async listarLocalidades(departamentoId) {
            try {
                this.loading.localidades = true;
                const { data } = await LocalidadeService.buscarLocalidadeNivelTres(departamentoId);
                this.opcoes.localidades = data
                    .map(item => ({ nome: item.nome, id: item.id }))
                    .sort((a, b) => this.orderName(a, b));
            } catch {
                this.$notify.error({ message: 'Error al buscar localidades.' });
            } finally {
                this.loading.localidades = false;
            }
        },

        async buscarPorCuitComDebounce(cuit) {
            if (!validateCuit(cuit)) return;
            await this.buscarPessoaRegistradaPorDocumento();
        },

        async adicionar() {
            if (this.botaoAgregarDesabilitado) return;
            const formularioValido = await this.validarFormulario();
            if (!formularioValido) return;

            this.adicionando = true;
            try {
                this.$notify.success({ message: 'Persona agregada em lista con éxito.' });
                this.$emit('adicionarPessoaManualmente', { ...this.formulario });
                this.resetarFormulario();
            } finally {
                this.adicionando = false;
            }
        },

        async buscarPessoaRegistradaPorDocumento() {
            this.pessoaJaCadastrada = false;
            try {
                const cuitSemFormatacao = this.formulario.cuit.replace(/\D/g, '');

                const { data } = await PessoaServiceArgentina
                    .buscarPessoaRegistradaPorDocumento(cuitSemFormatacao);

                this.pessoaJaCadastrada = data ?? false;

                if (this.pessoaJaCadastrada) {
                    this.$notify.warning({
                        title: 'Persona ya registrada',
                        message: 'Por favor, edite el registro existente.',
                        duration: 6000
                    });
                }
            } catch (error) {
                if (
                    error.response?.data?.message === 'HTTP 404 Not Found' ||
                    error.response?.data?.message === 'Persona no encontrada' ||
                    error.response?.status === 404
                ) {
                    this.pessoaJaCadastrada = false;
                } else {
                    this.$notify.error({
                        message: 'Error al validar el registro del documento en el sistema.'
                    });
                }
            }
        },

        resetarFormulario() {
            this.$refs.formCadastroPessoaRef.resetFields();
            this.formulario.pais = 'Argentina';
            this.pessoaJaCadastrada = false;
            this.opcoes.departamentos = [];
            this.opcoes.localidades = [];
        }
    },

    created() {
        this.debouncedBuscarPorCuit = debounce(this.buscarPorCuitComDebounce, 1000);
    },

    beforeDestroy() {
        if (this.debouncedBuscarPorCuit) {
            this.debouncedBuscarPorCuit.cancel();
        }

        this.resetarFormulario();
    },

    mounted() {
        this.listarProvincias();
    }
};
</script>

<style lang="scss">
#empresa-bloco-inserir-pessoa-manualmente {

    .empresa-bloco-inserir-pessoa-manualmente__title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 16px;
    }

    .el-icon-arrow-right:before {
        content: '\E7A0';
        font-size: 24px;
        padding: 10px;
        color: var(--primary);
    }

    h2.cadastro-pessoa__subtitulo {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 0;
        margin-left: 20px;
    }

    .el-card {
        border: none;
    }

    .el-collapse-item {
        border-radius: 10px;
        overflow: hidden;
    }

    .el-collapse-item__content {
        padding: 0;
    }

    .el-form-item {
        padding: 0 4px;
    }

    .el-select,
    .el-input,
    .el-date-picker,
    .el-button {
        width: 100%;
    }

    .row {
        align-items: flex-end;
        margin-bottom: 15px;
    }

    .el-form-item.is-required:not(.is-no-asterisk)
        > .el-form-item__label::before,
    .el-form-item.is-required:not(.is-no-asterisk)
        .el-form-item__label-wrap
        > .el-form-item__label:before {
        content: none !important;
        margin-right: 0 !important;
    }

    .el-form-item.is-required:not(.is-no-asterisk)
        > .el-form-item__label:after,
    .el-form-item.is-required:not(.is-no-asterisk)
        .el-form-item__label-wrap
        > .el-form-item__label:after {
        content: '*';
        color: #f56c6c;
        margin-left: 4px;
    }

}
</style>
